"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowserSupported = exports.isAppleSafari = exports.getTizenVersion = exports.getBrowserVersion = exports.getBrowser = exports.getOS = exports.isSamsungTV = exports.isLGTV = void 0;
const DesktopBrowserMaintained = {
    firefox: 85,
    chrome: 88,
    edge: 88,
    safari: 13,
    unknown: false,
};
const MobileBrowserMaintained = {
    firefox: false,
    chrome: 88,
    safari: 13,
    edge: false,
    unknown: false,
};
function isLGTV() {
    var _a, _b;
    return !!((_b = (_a = window.webOS) === null || _a === void 0 ? void 0 : _a.platform) === null || _b === void 0 ? void 0 : _b.tv);
}
exports.isLGTV = isLGTV;
function isSamsungTV() {
    return !!(window.tizen && window.webapis);
}
exports.isSamsungTV = isSamsungTV;
function getOS() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (/windows/.test(userAgent)) {
        return "Windows";
    }
    else if (/mac os/.test(userAgent)) {
        if (/iphone|ipod/.test(userAgent)) {
            return "iOS";
        }
        if (/ipad/.test(userAgent) || "ontouchstart" in document.documentElement) {
            return "iPadOS";
        }
        return "macOS";
    }
    else if (/android/.test(userAgent)) {
        return "Android";
    }
    else if (/linux/.test(userAgent)) {
        return "Linux";
    }
    return "unknown";
}
exports.getOS = getOS;
function getBrowser() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (/firefox/.test(userAgent)) {
        return "firefox";
    }
    else if (/edg/.test(userAgent) || /edga/.test(userAgent)) {
        return "edge";
    }
    else if (/chrome/.test(userAgent)) {
        return "chrome";
    }
    else if (/safari/.test(userAgent) &&
        /apple computer/.test(navigator.vendor.toLowerCase()) &&
        !/tizen/.test(userAgent) &&
        !/sopopenbrowser/.test(userAgent)) {
        return "safari";
    }
    return "unknown";
}
exports.getBrowser = getBrowser;
function getBrowserVersion() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const userAgent = window.navigator.userAgent.toLowerCase();
    const browser = getBrowser();
    let version = 0;
    if (browser === "firefox") {
        version = parseInt((_b = (_a = userAgent.match(/firefox\/(\d+)/)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : "", 10);
    }
    else if (browser === "edge") {
        version =
            parseInt((_d = (_c = userAgent.match(/edg\/(\d+)/)) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : "", 10) ||
                parseInt((_f = (_e = userAgent.match(/edga\/(\d+)/)) === null || _e === void 0 ? void 0 : _e[1]) !== null && _f !== void 0 ? _f : "", 10);
    }
    else if (browser === "chrome") {
        version = parseInt((_h = (_g = userAgent.match(/chrome\/(\d+)/)) === null || _g === void 0 ? void 0 : _g[1]) !== null && _h !== void 0 ? _h : "", 10);
    }
    else if (browser === "safari") {
        version = parseInt((_k = (_j = userAgent.match(/version\/(\d+)/)) === null || _j === void 0 ? void 0 : _j[1]) !== null && _k !== void 0 ? _k : "", 10);
    }
    return version;
}
exports.getBrowserVersion = getBrowserVersion;
/**
 * Get tizen version, returns 0 if not a tizen device or unsupported
 * @return {number}
 */
function getTizenVersion() {
    var _a;
    let version = 0;
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (isSamsungTV()) {
        version = parseFloat((_a = userAgent.split(" tv")[0].split("/").pop()) !== null && _a !== void 0 ? _a : "0");
    }
    return version;
}
exports.getTizenVersion = getTizenVersion;
function isAppleSafari() {
    const os = getOS();
    return getBrowser() === "safari" || os === "iOS" || os === "iPadOS";
}
exports.isAppleSafari = isAppleSafari;
function isBrowserSupported() {
    if (isSamsungTV() && getTizenVersion() >= 3) {
        return true;
    }
    if (isLGTV() && getBrowser() === "chrome" && getBrowserVersion() >= 38) {
        return true;
    }
    const os = getOS();
    const browser = getBrowser();
    const version = getBrowserVersion();
    const maintainedVersionMobile = MobileBrowserMaintained[browser];
    const maintainedVersionDesktop = DesktopBrowserMaintained[browser];
    if (os === "Android" &&
        maintainedVersionMobile &&
        version >= maintainedVersionMobile) {
        return true;
    }
    else if ((os === "iOS" || os === "iPadOS") &&
        maintainedVersionMobile
    // There seem to be no reliable way of determininig Safari version
    ) {
        return true;
    }
    else if ((os === "Windows" || os === "macOS") &&
        maintainedVersionDesktop &&
        version >= maintainedVersionDesktop) {
        return true;
    }
    return false;
}
exports.isBrowserSupported = isBrowserSupported;
//# sourceMappingURL=common.js.map